import React, { useContext, useEffect, useState } from "react";
import { callApi, isEmpty } from "bodycodi/cmap/app/js/common";
import Drawer from "@material-ui/core/Drawer";

import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import { StateContext as HomeStateContext } from "bodycodi/cmap/app/components/cmap2010/home";
import PickerHeader from "bodycodi/cmap/app/components/common/pickerHeader";
import empty from "bodycodi/cmap/app/img/member-profile-empty.png";
import smile from "bodycodi/cmap/app/img/smile.png";
import frown from "bodycodi/cmap/app/img/frown.png";
import cancle from "bodycodi/cmap/app/img/cancle.png";
import down from "bodycodi/cmap/app/img/down.png";
import NotificationPicker, { returnType } from "./notificationPicker";
import icon_right_arrow from "bodycodi/cmap/app/svg/icon_right_arrow.svg";

interface EtcAttendanceStep {
  d: any;
  setScheduleData?: (v: any) => void;
}

export const AppoinBtnPop = ({ d }: EtcAttendanceStep) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const { scheduleState } = d;

  const handleClose = () => {
    dispatch({ type: "POP_UP_OPEN", id: "SCHEDULE_BTN_POP", open: { etcScheduleBtnPop: false } });
  };

  const openAttandance = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "AP_SCHEDULE_CONFIRM_POP",
      open: { etcScheduleConfirmPop: true },
    });
  };
  const openAbsent = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "SCHEDULE_ABSENT_POP",
      open: { etcAbsentConfirmPop: true },
    });
  };

  return (
    <Drawer
      anchor="bottom"
      open={state.etcScheduleBtnPop}
      onClose={handleClose}
      className="picker-pop auto"
    >
      <PickerHeader title="출결 처리하기" onClose={handleClose} />
      <div className="picker-body">
        <div className="schedule-attendance">
          <div
            className={`schedule-attendance-btn green ${scheduleState === "E" && "disable"}`}
            onClick={
              scheduleState === "E"
                ? () => {
                    return;
                  }
                : openAttandance
            }
          >
            <img src={smile} />
            출석처리
          </div>
          <div
            className={`schedule-attendance-btn red ${scheduleState === "A" && "disable"}`}
            onClick={
              scheduleState === "A"
                ? () => {
                    return;
                  }
                : openAbsent
            }
          >
            <img src={frown} />
            결석처리
          </div>
        </div>
        <div className="schedule-attendance-text"></div>
      </div>
    </Drawer>
  );
};

export const AttendanceConfirm = ({ d, setScheduleData }: EtcAttendanceStep) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const { state: homeState } = useContext(HomeStateContext);

  const src = isEmpty(d.imgUrl) ? empty : d.imgUrl;

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "AP_SCHEDULE_CONFIRM_POP",
      open: { etcScheduleConfirmPop: false },
    });
  };

  const clickAttandance = () => {
    dispatch({ type: "LOADING_START" });
    callApi(
      "/schedule/reservation/ot-cs-state",
      {
        seqPartner: d.seqPartner,
        seqPartnerBranch: d.seqPartnerBranch,
        seqPartnerCoach: d.seqPartnerCoach,
        seqMember: d.seqMember,
        seqSchedule: d.seqSchedule,
        scheduleState: "E",
        startDate: d.startDate,
      },
      "PATCH"
    )
      .then((res) => {
        if (res.MsgVO) {
          if (res.MsgVO.msgCd === "CMAP2020-00") {
            handleClose();
            dispatch({
              type: "POP_UP_OPEN",
              id: "SCHEDULE_BTN_POP",
              open: { etcScheduleBtnPop: false },
            });
            homeState.scheduleDtlPop.update();
            dispatch({
              type: "UPDATE",
              data: {
                toast: true,
                toastText: "<span>" + d.name + "</span>님을 <span>출석처리</span>했습니다.",
              },
            });
            if (setScheduleData) {
              setScheduleData((previousValue: any) => ({
                ScheduleVO: {
                  ...previousValue.ScheduleVO,
                  scheduleState: "E",
                },
              }));
            }
          } else {
            dispatch({ type: "UPDATE", data: { toast: true, toastText: res.MsgVO.msgCtnt } });
          }
        }
      })
      .finally(() => {
        dispatch({ type: "LOADING_END" });
      });
  };

  return (
    <Drawer
      anchor="bottom"
      open={state.etcScheduleConfirmPop}
      onClose={handleClose}
      className="picker-pop"
    >
      <div className="schedule-btn-pop">
        <img className="member" src={src} />
        <div className="member-name">
          {d.name}님을
          <br />
          <span>출석처리</span> 할까요?
        </div>
        <div className="member-decution">출결상태만 변경됩니다.</div>
        <div className="member-decution-cnt">
          <ul>
            {d.scheduleState === "A" ? (
              <li className="union red bigger">결석</li>
            ) : (
              <li className="union blue bigger">예약</li>
            )}
          </ul>
          <img src={icon_right_arrow} />
          <ul>
            <li className="union green bigger">출석</li>
          </ul>
        </div>
        <div className="member-decution-btn-wrap">
          <div className="btn cancle" onClick={handleClose}>
            취소
          </div>
          <div className="btn attandance" onClick={clickAttandance}>
            출석처리
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export const AbsentConfirm = ({ d, setScheduleData }: EtcAttendanceStep) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const { state: homeState } = useContext(HomeStateContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "SCHEDULE_CONFIRM_POP",
      open: { etcAbsentConfirmPop: false },
    });
  };

  const src = isEmpty(d.imgUrl) ? empty : d.imgUrl;

  const clickAbsent = () => {
    dispatch({ type: "LOADING_START" });
    callApi(
      "/schedule/reservation/ot-cs-state",
      {
        seqPartner: d.seqPartner,
        seqPartnerBranch: d.seqPartnerBranch,
        seqPartnerCoach: d.seqPartnerCoach,
        seqMember: d.seqMember,
        seqSchedule: d.seqSchedule,
        scheduleState: "A",
        startDate: d.startDate,
      },
      "PATCH"
    )
      .then((res) => {
        if (res.MsgVO) {
          if (res.MsgVO.msgCd === "CMAP2020-00") {
            handleClose();
            dispatch({
              type: "POP_UP_OPEN",
              id: "SCHEDULE_BTN_POP",
              open: { etcScheduleBtnPop: false },
            });
            homeState.scheduleDtlPop.update();
            dispatch({
              type: "UPDATE",
              data: {
                toast: true,
                toastText: "<span>" + d.name + "</span>님을 <span>결석처리</span>했습니다.",
              },
            });
            if (setScheduleData) {
              setScheduleData((previousValue: any) => ({
                ScheduleVO: {
                  ...previousValue.ScheduleVO,
                  scheduleState: "A",
                },
              }));
            }
          } else {
            dispatch({ type: "UPDATE", data: { toast: true, toastText: res.MsgVO.msgCtnt } });
          }
        }
      })
      .finally(() => {
        dispatch({ type: "LOADING_END" });
      });
  };

  return (
    <Drawer
      anchor="bottom"
      open={state.etcAbsentConfirmPop}
      onClose={handleClose}
      className="picker-pop"
    >
      <div className="schedule-btn-pop">
        <img className="member" src={src} />
        <div className="member-name">
          {d.name}님을
          <br />
          <span className="red">결석처리</span> 할까요?
        </div>
        <div className="member-decution">출결상태만 변경됩니다.</div>
        <div className="member-decution-cnt">
          <ul>
            {d.scheduleState === "E" ? (
              <li className="union green bigger">출석</li>
            ) : (
              <li className="union blue bigger">예약</li>
            )}
          </ul>
          <img src={icon_right_arrow} />
          <ul>
            <li className="union red bigger">결석</li>
          </ul>
        </div>
        <div className="member-decution-btn-wrap">
          <div className="btn cancle" onClick={handleClose}>
            취소
          </div>
          <div className="btn absent" onClick={clickAbsent}>
            결석처리
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export const RsrvCancleConfirm = ({ d }: EtcAttendanceStep) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const { state: homeState } = useContext(HomeStateContext);
  const src = isEmpty(d.imgUrl) ? empty : d.imgUrl;

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "RSRV_CANCLE_CONFIRM_POP",
      open: { etcCancelConfirmPop: false },
    });
  };

  const handleClickCancelConfirm = () => {
    dispatch({
      type: "ALERT_SETTING",
      data: {
        alert: true,
        cancleYn: "D",
        redYn: true,
        header: "스케줄 취소",
        body: "정말로 해당 스케줄을\n 취소할까요?",
        cancelAlert: () => ({}),
        closeAlert: handleClickCancel,
      },
    });
  };
  const handleClickCancel = () => {
    dispatch({ type: "LOADING_START" });
    callApi(
      "/schedule/reservation/ot-cs-state",
      {
        seqPartner: d.seqPartner,
        seqPartnerBranch: d.seqPartnerBranch,
        seqPartnerCoach: d.seqPartnerCoach,
        seqMember: d.seqMember,
        seqSchedule: d.seqSchedule,
        scheduleState: "C",
        cnlMsgCtnt: "",
        startDate: d.startDate,
      },
      "PATCH"
    )
      .then((res) => {
        if (res.MsgVO) {
          if (res.MsgVO.msgCd === "CMAP2020-00") {
            handleClose();
            dispatch({
              type: "POP_UP_OPEN",
              id: "SCHEDULE_DTL_POP",
              open: { scheduleDtlPop: false },
            });
            dispatch({
              type: "POP_UP_OPEN",
              id: "SCHEDULE_BTN_POP",
              open: { etcScheduleBtnPop: true },
            });
            homeState.scheduleDtlPop.update();
            dispatch({
              type: "UPDATE",
              data: {
                toast1: true,
                toastText: "<span>" + d.name + "</span>님을 <span>예약 취소 처리</span>했습니다.",
              },
            });
            dispatch({
              type: "POP_UP_OPEN",
              id: "SCHEDULE_BTN_POP",
              open: { etcScheduleBtnPop: false },
            });
          } else {
            dispatch({ type: "UPDATE", data: { toast1: true, toastText: res.MsgVO.msgCtnt } });
          }
        }
      })
      .finally(() => {
        dispatch({ type: "LOADING_END" });
      });
  };

  return (
    <>
      <Drawer
        anchor="bottom"
        open={state.etcCancelConfirmPop}
        onClose={handleClose}
        className="picker-pop"
      >
        <div className="schedule-btn-pop">
          <img className="member" src={src} />
          <div className="member-name">
            {d.name}님을
            <br />
            <span className="gray">예약취소</span> 할까요?
          </div>
          <div className="member-decution">
            예약취소 전 회원님께 <br />
            <span className="red">스케줄 취소 사유를 꼭 안내해주세요!</span>
          </div>
          <div className="member-decution-btn-wrap">
            <div className="btn cancle" onClick={handleClose}>
              취소
            </div>
            <div className="btn rsrv-cancle" onClick={handleClickCancelConfirm}>
              예약취소
            </div>
          </div>
        </div>
      </Drawer>
    </>
  );
};

// 220620
// 예약취소시 문구를 선택,작성해도 멤버스앱 알림으로 전달되지가 않아서 이번 단계에서는 취소됨
// export const RsrvCancleConfirm = ({ d }: EtcAttendanceStep) => {
//   const { dispatch } = useContext(DispatchContext);
//   const { state } = useContext(StateContext);
//   const { state: homeState } = useContext(HomeStateContext);
//   const [selected, setSelected] = useState<returnType>({ notice: { value: "", text: "" } });
//   const [cnlMsgCtnt, setCnlMsgCtnt] = useState("");
//   const src = isEmpty(d.imgUrl) ? empty : d.imgUrl;

//   const cancelReasonSchedule =
//     "스케줄이 겹치게 되어 예약취소하게되었습니다. 문의사항이 있을 시 센터로 연락주시기 바랍니다.";
//   const cancelReasonPersoner =
//     "회원님 불편을 드려 죄송합니다. 개인사정이 있어서 예약 취소하게 되었습니다. 문의사항이 있으시면 센터로 연락 부탁드립니다.";

//   useEffect(() => {
//     if (selected.notice.value === "schedule") {
//       setCnlMsgCtnt(cancelReasonSchedule);
//     } else if (selected.notice.value === "personer") {
//       setCnlMsgCtnt(cancelReasonPersoner);
//     } else {
//       setCnlMsgCtnt("");
//     }
//   }, [selected]);

//   const onSelect = (data: returnType) => {
//     setSelected({ notice: data.notice });
//   };

//   const handleClickOpenPicker = () => {
//     dispatch({ type: "POP_UP_OPEN", id: "NOTIFICATION_POP", open: { notificationPop: true } });
//   };

//   const handleClose = () => {
//     dispatch({
//       type: "POP_UP_OPEN",
//       id: "RSRV_CANCLE_CONFIRM_POP",
//       open: { etcCancelConfirmPop: false },
//     });
//   };

//   const handleChangeInput = (e: any) => {
//     setCnlMsgCtnt(e.currentTarget.value);
//   };

//   const handleClickCancel = () => {
//     if (cnlMsgCtnt === "" && selected.notice.value) {
//       dispatch({
//         type: "UPDATE",
//         data: {
//           toast1: true,
//           toastText: "<span style='text-align:center'>내용을 입력해주세요.</span>",
//         },
//       });
//       return;
//     }
//     callApi(
//       "/schedule/reservation/ot-cs-state",
//       {
//         seqPartner: d.seqPartner,
//         seqPartnerBranch: d.seqPartnerBranch,
//         seqPartnerCoach: d.seqPartnerCoach,
//         seqMember: d.seqMember,
//         seqSchedule: d.seqSchedule,
//         scheduleState: "C",
//         cnlMsgCtnt: cnlMsgCtnt,
//         startDate: d.startDate,
//       },
//       "PATCH"
//     ).then((res) => {
//       if (res.MsgVO) {
//         if (res.MsgVO.msgCd === "CMAP2020-00") {
//           handleClose();
//           dispatch({
//             type: "POP_UP_OPEN",
//             id: "SCHEDULE_DTL_POP",
//             open: { scheduleDtlPop: false },
//           });
//           dispatch({
//             type: "POP_UP_OPEN",
//             id: "SCHEDULE_BTN_POP",
//             open: { etcScheduleBtnPop: true },
//           });
//           homeState.scheduleDtlPop.update();
//           dispatch({
//             type: "UPDATE",
//             data: {
//               toast1: true,
//               toastText: "<span>" + d.name + "</span>님을 <span>예약 취소 처리</span>했습니다.",
//             },
//           });
//           dispatch({
//             type: "POP_UP_OPEN",
//             id: "SCHEDULE_BTN_POP",
//             open: { etcScheduleBtnPop: false },
//           });
//         } else {
//           dispatch({ type: "UPDATE", data: { toast1: true, toastText: res.MsgVO.msgCtnt } });
//         }
//       }
//     });
//   };

//   return (
//     <>
//       <Drawer
//         anchor="bottom"
//         open={state.etcCancelConfirmPop}
//         onClose={handleClose}
//         className="picker-pop"
//       >
//         <div className="schedule-btn-pop">
//           <img className="member" src={src} />
//           <div className="member-name">
//             {d.name}님을
//             <br />
//             <span className="gray">예약취소</span> 할까요?
//           </div>
//           <div className="member-decution">
//             회원님께 예약취소에 대한 안내사항을 <br />
//             알림으로 전달드려요.
//           </div>
//           <div
//             className={
//               "member-picker-input" + (isEmpty(selected.notice.value) ? " place-holder" : "")
//             }
//             onClick={handleClickOpenPicker}
//           >
//             <div className="text">
//               {isEmpty(selected.notice.value) && "회원님께 안내할까요? (선택)"}
//               {selected.notice.text}
//             </div>
//             <img src={down} />
//           </div>
//           {!isEmpty(selected.notice.value) && (
//             <>
//               <div className="member-picker-text">
//                 <textarea
//                   placeholder="안내사항은 70자까지 입력가능합니다."
//                   maxLength={70}
//                   value={cnlMsgCtnt}
//                   onChange={handleChangeInput}
//                 />
//               </div>
//               <div className="textarea-length">{cnlMsgCtnt.length}/70</div>
//             </>
//           )}
//           <div className="member-decution-btn-wrap">
//             <div className="btn cancle" onClick={handleClose}>
//               취소
//             </div>
//             <div className="btn rsrv-cancle" onClick={handleClickCancel}>
//               예약취소
//             </div>
//           </div>
//         </div>
//         <NotificationPicker onSelect={onSelect} selected={selected} title="안내사항 선택" />
//       </Drawer>
//     </>
//   );
// };
